function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M108.224 105.975L74.109 54.004a1.635 1.635 0 00-1.364-.74H46.74c-.546 0-1.053.272-1.365.74l-34.114 51.971a1.713 1.713 0 00-.079 1.677c.273.506.82.857 1.443.857h94.234c.585 0 1.131-.312 1.443-.857.273-.546.273-1.17-.078-1.677zM47.636 56.499h1.56l-25.537 48.735h-8.032l32.01-48.735zM61.4 105.234v-6.51h-3.236v6.51H27.402L52.9 56.499h5.263v1.638H61.4v-1.638h5.264l25.498 48.735H61.399zm34.427 0L70.327 56.499h1.56l31.97 48.735h-8.031z",
  fill: "#384B51"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M61.36 59.735h-3.236v3.236h3.236v-3.236zM61.36 66.246h-3.236v4.874h3.236v-4.874zM61.36 74.356h-3.236v6.51h3.236v-6.51zM61.36 85.74h-3.236v8.11h3.236v-8.11z",
  fill: "#384B51"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59.762 49.988c.468 0 .935-.195 1.247-.585 1.365-1.637 13.373-16.219 13.373-23.782 0-8.071-6.55-14.621-14.62-14.621s-14.62 6.55-14.62 14.62c0 7.564 12.007 22.146 13.372 23.783.312.39.78.585 1.248.585zm0-35.713c6.277 0 11.345 5.107 11.384 11.385 0 4.834-7.33 15.088-11.384 20.156-4.055-5.107-11.385-15.322-11.385-20.157.039-6.316 5.108-11.384 11.385-11.384z",
  fill: "#00BAC3"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M66.273 24.022c0-3.587-2.924-6.511-6.511-6.511s-6.511 2.924-6.511 6.511 2.924 6.511 6.51 6.511c3.587-.039 6.512-2.924 6.512-6.511zm-9.747 0a3.228 3.228 0 013.236-3.236 3.228 3.228 0 013.236 3.236 3.228 3.228 0 01-3.236 3.236 3.228 3.228 0 01-3.236-3.236z",
  fill: "#00BAC3"
});

function SvgDistanceRoad(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgDistanceRoad;